module.exports = __webpack_public_path__ + "static/media/gry-edukacyjne-dla-9-latka-10-latka.81e25a14.png";